import React from 'react';
import { useTheme } from '../../hooks/useTheme';

const SessionStats = ({ sessions }) => {
  const { theme } = useTheme();
  
  const todaySessions = sessions.filter(s => 
    new Date(s.date).toDateString() === new Date().toDateString()
  ).length;
  
  const totalMinutes = sessions.reduce((acc, s) => acc + s.duration, 0);
  const totalHours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className={`p-6 rounded-xl ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
        <h3 className="font-semibold mb-4">Today's Sessions</h3>
        <div className="text-3xl font-bold text-blue-600">{todaySessions}</div>
        <p className="text-sm text-gray-500 mt-1">Completed sessions</p>
      </div>

      <div className={`p-6 rounded-xl ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
        <h3 className="font-semibold mb-4">Total Focus Time</h3>
        <div className="text-3xl font-bold text-green-600">
          {totalHours}h {remainingMinutes}m
        </div>
        <p className="text-sm text-gray-500 mt-1">This week</p>
      </div>
    </div>
  );
};

export default SessionStats;